<template>
    <div class="row">
        <div class="col-12" v-if="zona">
            <TerrenoJuegoComponent :direccion_campo="zona.direccion_campo"/>
            
            <div class="container-butacas-wrapper" v-if="!loading && zona.with_seats">
                <div :class="'container-butacas text-align-' + zona.print_align">
                    <template v-for="(butacas, fila) in filas">
                        <span :key="fila">
                            <span class="fila">{{ fila }}</span>
                            <template v-for="(asiento, index) in butacas">
                                <AsientoComponent :asiento="asiento" :fila="fila" :key="index+'_2'" @toggle="() => toggleSeleccion(fila, asiento, true, true)"/>
                            </template>

                            <br />
                        </span>
                    </template>
                </div>
            </div>
            <div v-if="!zona.with_seats">
                <FormInput label="Nº de butacas a bloquear" type="number" v-model="n_butacas" />
            </div>
            <div class="col-12 text-center" style="height: 150px" v-if="loading">
                <LoaderComponent/>
            </div>
        </div>
        <leyenda-color />
        <div class="col-12">
            <Button class="m-3" @click="selectAll">Seleccionar todas</Button>
            <Button class="m-3" @click="clearAll">Limpiar todas</Button>
        </div>

        <div class="col-12" v-if="!loading">   
            <div class="form-group">
                <label>AFORO REGIÓN: {{ zona.aforo ? zona.aforo : zona.total_asientos }}</label>
            </div>
            <div class="form-group">
                <label>AFORO BLOQUEADO: {{ zona.bloqueados }}</label>
            </div>
            <div class="form-group">
                <label>AFORO A LA VENTA: {{ total_en_venta }}</label>
            </div>
        </div>

        <div class="col-12" v-if="!loading">
            <FormInput label="Concepto" v-model="concepto" />
        </div>  
        <div class="col-12" v-if="!loading">
            <Button class="btn-lg btn-block" type="button" name="button" @click="bloquearAsientos" :disabled="bloquear_boton || bloqueando">Bloquear / Liberar</Button>
            <div class="col-12 text-center" v-if="bloqueando" style="height: 150px">
                <LoaderComponent/>
            </div>
        </div>
    </div>
</template>

<script>
    import AsientoComponent from "@/components/backend/stepper/components/AsientoComponent";
    import TerrenoJuegoComponent from '@/components/common/Asientos/TerrenoJuegoComponent.vue';
    import LoaderComponent from '@/components/preloader/LoaderComponent';
    import LeyendaColor from './LeyendaColor.vue';

    export default {
        props: {
            zona_seleccionada: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                filas: null,
                asientos: [],
                n_butacas: 0,
                concepto: '',
                bloqueando: false,
                zona: null,
            }
        },
        created() {
            this.zona = Object.assign({}, this.zona_seleccionada);
            this.getZona(this.zona.id);
        },
        computed: {
            total_en_venta() {
                var aforo = this.zona.aforo ? this.zona.aforo : this.zona.total_asientos;

                return aforo - this.zona.bloqueados - this.zona.ocupados;
            },
            bloquear_boton() {
                return this.asientos.length === 0 && this.n_butacas === 0;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        methods: {
            getZona(id) {
                this.loading = true;
                const params = {
                    filters: {
                        zona_id: id,
                        conf: true
                    },
                };

                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.filas = res.data.configuracion_asientos;
                    this.loading = false;
                    this.zona.total_asientos = res.data.total_asientos;
                    this.zona.bloqueados = res.data.bloqueados;
                    this.zona.ocupados = res.data.ocupados;
                });
            },
            toggleSeleccion : function(fila, asiento) {
                //lo anado a asientos_seleccionados
                //si no he seleccionado ninguna butaca y ademas tengo un abonado
                if (asiento.ocupado != 1) {
                    for(var i in this.filas[fila]) {
                        if(this.filas[fila][i].asiento == asiento.asiento) {
                            if(this.filas[fila][i].seleccionado) {
                                //si el asiento estaba seleccionado, lo quito de asientos
                                for(var j in this.asientos) {
                                    if(this.asientos[j].row == fila && this.asientos[j].seat == asiento.asiento) {
                                        this.asientos.splice(j, 1);
                                    }
                                }
                            } else {
                                //si el asiento no estaba seleccionado es porque lo voy a anadir, asi que lo meto en asientos
                                const data = {
                                    row : fila,
                                    seat : this.filas[fila][i].asiento,
                                    region_id : this.zona.id,
                                    zona_nombre : this.zona.name,
                                }
                                this.asientos.push(data);
                            }
                            this.filas[fila][i].seleccionado = !this.filas[fila][i].seleccionado;
                        }
                    }
                }
            },
            selectAll() {
                if(this.zona.with_seats) {
                    for(var fila in this.filas) {
                        for(var asiento in this.filas[fila]) {
                            if((this.filas[fila][asiento].ocupado == 0 || this.filas[fila][asiento].ocupado == 3) && !this.filas[fila][asiento].seleccionado) {
                                //si el asiento no estaba seleccionado es porque lo voy a anadir, asi que lo meto en asientos
                                const data = {
                                    row : fila,
                                    seat : this.filas[fila][asiento].asiento,
                                    region_id : this.zona.id,
                                    zona_nombre : this.zona.name,
                                }
                                this.asientos.push(data);

                                this.filas[fila][asiento].seleccionado = !this.filas[fila][asiento].seleccionado;
                            }
                        }
                    } 
                } else {
                    this.n_butacas = this.zona.aforo;
                }                
            },
            clearAll() {
                if(this.zona.with_seats) {
                    this.asientos = [];
                    for(var fila in this.filas) {
                        for(var asiento in this.filas[fila]) {
                            if(this.filas[fila][asiento].seleccionado) {
                                //si el asiento estaba seleccionado, lo quito de asientos

                                this.filas[fila][asiento].seleccionado = !this.filas[fila][asiento].seleccionado;
                            }
                        }
                    } 
                } else {
                    this.n_butacas = this.zona.aforo;
                }                
            },
            bloquearAsientos() {
                this.bloqueando = true;
                const params = {
                    filters: {
                        lista_id: this.$store.getters.getListaId
                    },
                    asientos: this.asientos,
                    concepto: this.concepto,
                    lista_id: this.$store.getters.getListaId,
                    n_butacas: this.n_butacas,
                    zona_id: this.zona.id
                };

                if(this.etiqueta){
                    params.etiqueta_bloqueo_id = this.etiqueta.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.bloquear.asientos'), params).then(res => {
                    this.bloqueando = false;
                    this.asientos = [];
                    this.getZona(this.zona.id);
                });
            },
        },
        components: {
            AsientoComponent, TerrenoJuegoComponent, LoaderComponent, LeyendaColor
        }
    }
</script>